import styled from 'styled-components'
import { BaseColor, themeColor, rem } from '~theme'
import { Button as ButtonBase, ButtonSizeList } from '~components/Button'
import { InputBase } from '~components/Form/TextualFormElement'
import { SizeType } from './Stepper.types'

interface InnerProps {
  size: SizeType
}

interface InputProps {
  size: SizeType
}

function getSize(size: SizeType) {
  return ButtonSizeList[size]
}

function getMargin(size: SizeType) {
  switch (size) {
    case 'large':
      return rem(-4)
    case 'medium':
      return rem(-2)
    default:
      return 0
  }
}

export const Container = styled.div`
  position: relative;
  display: flex;
`

export const Inner = styled.div<InnerProps>`
  position: relative;
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
  border-radius: ${props => getSize(props.size)};
  text-align: center;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid ${themeColor(BaseColor.shade_40)};
    border-radius: inherit;
  }
`

export const Input = styled(InputBase)<InputProps>`
  position: relative;
  width: ${props => getSize(props.size)};
  margin: 0 ${props => getMargin(props.size)};
  background: transparent;
  border: none;
  padding: 0;

  && > input {
    text-align: center;
    padding-left: 0;
    padding-right: 0;
  }
`

export const Button = styled(ButtonBase)`
  z-index: 1;
  flex-shrink: 0;
`
